<template>
  <div>
    <h5>Company Directorships</h5>

    <div v-for="companyappointment in officer.appointments" :key="companyappointment.id">
      <company-directorship
        :companyappointment="companyappointment"
        :report="report"
      ></company-directorship>
    </div>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import CompanyDirectorship from '@/components/reports/panels/directors/CompanyDirectorship';

export default {
  components: {
    CompanyDirectorship,
  },
  mixins: [toolsMixin],
  props: ['officer', 'report'],
};
</script>
